$(document).ready(function () {
    $("#abre-menu").on("click", function (e) {
        $("#menu").addClass("visible");
    });

    $("#cerrar-menu").on("click", function (e) {
        $("#menu").removeClass("visible");
    });
});
